import { userHasScopes } from 'packages/lib/auth';
import useSWR from 'swr';

export const useHasRosterManagementScope = () => {
  const {
    // data: hasRMScope,
    isLoading,
  } = useSWR('has-roster-management-scope', () =>
    userHasScopes(['roster-management'])
  );

  const hasRMScope_TEMP_REPLACE_WITH_ACTUAL_VALUE = true;

  return isLoading ? false : hasRMScope_TEMP_REPLACE_WITH_ACTUAL_VALUE;
};
